
// const calculateHighlights = (hotels = []) => {
//   const totalHotels = hotels.length;

//   // Total ballrooms
//   const totalBallrooms = hotels.reduce(
//     (total, hotel) => total + (hotel.ballrooms?.length || 0),
//     0
//   );

//   // Total other venue spaces
//   const totalVenueSpaces = hotels.reduce(
//     (total, hotel) => total + (hotel.venue_spaces?.length || 0),
//     0
//   );

//   // Combined event spaces
//   const totalEventSpaces = totalBallrooms + totalVenueSpaces;

//   // Unique cities
//   const cities = new Set(
//     hotels
//       .map((hotel) => hotel.city?.trim().toLowerCase())
//       .filter(Boolean)
//   );

//   // Unique states
//   const states = new Set(
//     hotels
//       .map((hotel) => hotel.state?.trim().toLowerCase())
//       .filter(Boolean)
//   );

//   return [
//     {
//       id: "hotels",
//       icon: "🏨",
//       value: totalHotels.toLocaleString("en-IN"),
//       title: "Hotels Onboarded",
//       description: "Hotels listed on our platform",
//     },
//     {
//       id: "ballrooms",
//       icon: "🏛️",
//       value: totalBallrooms.toLocaleString("en-IN"),
//       title: "Ballrooms",
//       description: "Dedicated ballroom inventory",
//     },
//     {
//       id: "venue-spaces",
//       icon: "🏢",
//       value: totalVenueSpaces.toLocaleString("en-IN"),
//       title: "Other Event Spaces",
//       description: "Meeting rooms and additional venues",
//     },
//     {
//       id: "event-spaces",
//       icon: "✨",
//       value: totalEventSpaces.toLocaleString("en-IN"),
//       title: "Total Event Spaces",
//       description: "Combined ballroom and venue inventory",
//     },
//     {
//       id: "cities",
//       icon: "📍",
//       value: cities.size.toLocaleString("en-IN"),
//       title: "Cities Covered",
//       description: "Destinations across India",
//     },
//     {
//       id: "states",
//       icon: "🗺️",
//       value: states.size.toLocaleString("en-IN"),
//       title: "States Covered",
//       description: "States and union territories",
//     },
//   ];
// };

// export default calculateHighlights;


import {
  FaHotel,
  FaLandmark,
  FaBuilding,
  FaLayerGroup,
  FaMapMarkerAlt,
  FaMap,
} from "react-icons/fa";

const calculateHighlights = (hotels = []) => {
  if (!Array.isArray(hotels)) hotels = [];

  const totalHotels = hotels.length;

  // Total ballrooms
  const totalBallrooms = hotels.reduce(
    (total, hotel) => total + (hotel.ballrooms?.length || 0),
    0
  );

  // Total other venue spaces
  const totalVenueSpaces = hotels.reduce(
    (total, hotel) => total + (hotel.venue_spaces?.length || 0),
    0
  );

  // Combined event spaces
  const totalEventSpaces = totalBallrooms + totalVenueSpaces;

  // Unique cities
  const cities = new Set(
    hotels
      .map((hotel) => hotel.city?.trim().toLowerCase())
      .filter(Boolean)
  );

  // Unique states
  const states = new Set(
    hotels
      .map((hotel) => hotel.state?.trim().toLowerCase())
      .filter(Boolean)
  );

  return [
    {
      id: "hotels",
      icon: FaHotel,
      value: totalHotels.toLocaleString("en-IN"),
      title: "Hotels Onboarded",
      description: "Hotels listed on our platform",
    },
    {
      id: "ballrooms",
      icon: FaLandmark,
      value: totalBallrooms.toLocaleString("en-IN"),
      title: "Ballrooms",
      description: "Dedicated ballroom inventory",
    },
    {
      id: "venue-spaces",
      icon: FaBuilding,
      value: totalVenueSpaces.toLocaleString("en-IN"),
      title: "Other Event Spaces",
      description: "Meeting rooms and additional venues",
    },
    {
      id: "event-spaces",
      icon: FaLayerGroup,
      value: totalEventSpaces.toLocaleString("en-IN"),
      title: "Total Event Spaces",
      description: "Combined ballroom and venue inventory",
    },
    {
      id: "cities",
      icon: FaMapMarkerAlt,
      value: cities.size.toLocaleString("en-IN"),
      title: "Cities Covered",
      description: "Destinations across India",
    },
    {
      id: "states",
      icon: FaMap,
      value: states.size.toLocaleString("en-IN"),
      title: "States Covered",
      description: "States and union territories",
    },
  ];
};

export default calculateHighlights;
